import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
    FormControl: {
        width: 550
    }
});

export const MSESelectGroup = (props) => {
    const classes = useStyles();
    const {
        inputLabel,
        label,
        value,
        handleChange,
        disabled,
        nameValue,
        ...others
    } = props;
    const groups = ['A', 'B', 'C', 'D', 'E'];

    return (
        <FormControl className={classes.formControl}>
            <InputLabel>
                {inputLabel}
            </InputLabel>
            <Select
                labelId={`formcontrol-select-group-${nameValue}`}
                id={`formcontrol-select-group-${nameValue}`}
                value={value || ''}
                onChange={e => handleChange(nameValue,e)}
                required
                className={classes.FormControl}
            >
                {groups.map((group, i) => <MenuItem value={group} key={`f-s-mi-${nameValue}-${i}`}>{group}</MenuItem>)}
            </Select>
        </FormControl>
    );
};